import { FeatureToggleClientService } from 'feature-toggle-client';
export const CoolStuffAction = 'easter-egg';
export class CoolStuffActionFeature {
    static coolStuffActionApplicationEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(CoolStuffAction);
    }
}
